/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-array-constructor */
import { ARK_game_arena_connector } from "./ArenaAPI"
export const ArenaHelper = function () {
    if (window.ArenaXApi !== undefined && window.ArenaXApi !== null) {
        this.arenaXApi = ArenaXApi.getInstance();
    }

    this.testActionCallback = null;

    // internal callbacks that the game can register for midrolls
    this.pauseCallback = null;
    this.resumeCallback = null;

    // "actions" for arena api's
    this.pauseHandler = this.handleMidrollStart.bind(this);
    this.resumeHandler = this.handleMidrollFinish.bind(this);

    if (this.arenaXApi) {
        this.arenaXApi.addAction("GAME_PAUSE", this.pauseHandler);
        this.arenaXApi.addAction("GAME_RESUME", this.resumeHandler);
    }
    else {
        ARK_game_arena_connector.init();
        ARK_game_arena_connector.registerAction("pause", this.pauseHandler);
        ARK_game_arena_connector.registerAction("resume", this.resumeHandler);
    }
};

ArenaHelper.prototype = {

    init: function (pauseCallback, resumeCallback) {
        this.pauseCallback = pauseCallback;
        this.resumeCallback = resumeCallback;
    },

    getParam: function (paramName, defaultValue) {
        if (this.arenaXApi) {
            // TODO(ebuchholz): implement phoenix's way of getting arena parameters. For now, hard-coded values for certain known parameters
            switch (paramName) {
                default:
                    return defaultValue;
                case "configURL":
                    // TODO(ebuchholz): Host a config file and puzzles somewhere external, rather than packing them with the game
                    return "";
            }
        }
        else {
            return ARK_game_arena_connector.getParam(paramName, defaultValue);
        }
    },

    handleMidrollRequest: function () {
        if (this.arenaXApi) {
            this.arenaXApi.dispatch({ type: "PAUSE_READY", payload: null });
        }
        else {
            ARK_game_arena_connector.fireEventToArena("pause_ready");
        }
    },

    handleMidrollStart: function () {
        if (this.pauseCallback) {
            this.pauseCallback.call();
        }
    },

    handleMidrollFinish: function () {
        if (this.resumeCallback) {
            this.resumeCallback.call();
        }
    },

    handlePauseRequest: function () {
        if (this.arenaXApi) {
            //this.arenaXApi.dispatch({ type: "PAUSE_READY", payload: null });
        }
        else {
            ARK_game_arena_connector.fireEventToArena("pause");
        }
    },

    handleResumeRequest: function () {
        if (this.arenaXApi) {
            //this.arenaXApi.dispatch({ type: "PAUSE_READY", payload: null });
        }
        else {
            ARK_game_arena_connector.fireEventToArena("resume");
        }
    },

    handleSaveLocalProgress: function (dataString) {
        if (this.arenaXApi) {
            return;
        }
        else {
            ARK_game_arena_connector.fireEventToArena("local_save", dataString);
        }
    },

    handleEventChange: function () {
        if (this.arenaXApi) {
            this.arenaXApi.dispatch({ type: "EVENT_CHANGE", payload: null });
        }
        else {
            ARK_game_arena_connector.fireEventToArena("event_change");
        }
    },

    handleGameStart: function () {
        if (this.arenaXApi) {
            this.arenaXApi.dispatch({ type: "GAME_START", payload: null });
        }
        else {
            ARK_game_arena_connector.fireEventToArena("game_start");
        }
    },

    handleGameEnd: function (score, reason) {
        if (this.arenaXApi) {
            this.arenaXApi.dispatch({ type: "CHANGE_SCORE", payload: score });
            this.arenaXApi.dispatch({ type: "GAME_END", payload: null });
        }
        else {
            ARK_game_arena_connector.changeScore(score, reason);
            ARK_game_arena_connector.fireEventToArena("game_end");
        }
    },

    handleLevelStart: function () {
        if (this.arenaXApi) {
            //this.arenaXApi.dispatch({ type: "PAUSE_READY", payload: null });
        }
        else {
            ARK_game_arena_connector.fireEventToArena("level_start");
        }
    },

    handleLevelComplete: function (score) {
        if (this.arenaXApi) {
            //this.arenaXApi.dispatch({ type: "PAUSE_READY", payload: null });
        }
        else {
            ARK_game_arena_connector.fireEventToArena("level_complete", "score=" + score);
        }
    },

    initTestingEnvironment: function () {
        if (this.arenaXApi) {
            this.arenaXApi.addAction("TEST_ACTION", this.processTestAction.bind(this));
            this.arenaXApi.dispatch({ type: "TEST_READY", payload: null });
            return;
        }
        else {
            ARK_game_arena_connector.registerAction("test_action", this.processTestAction.bind(this));
            ARK_game_arena_connector.initTestingEnvironment();
        }
    },

    processTestAction: function (params) {
        for (var i = 0; i < params.length; i++) {
            var obj = params[i];
            if (obj.name === "test_object") {
                var testingParams = obj.value.split(";");
                var testing_action = testingParams[0];
                if (this.testActionCallback) {
                    this.testActionCallback(testing_action);
                }
                break;
            }
        }
    },

    shouldShowInternalGameEnd: function () {
        if (this.arenaXApi) {
            return false;
        }

        var showGameEnd = ARK_game_arena_connector.showGameEnd();
        var showInternalGameEnd = (showGameEnd === true);
        return showInternalGameEnd;
    },

    getAbsoluteURL: function (relativeURL) {
        if (this.arenaXApi) {
            return [this.arenaXApi.assetOriginUrl, relativeURL].join("");
        }
        return relativeURL;
    },

    getLocale: function () {
        if (this.arenaXApi) {
            return this.arenaXApi.locale;
        }
        else {
            return ARK_game_arena_connector.getParam("locale", "en-US");
        }
    },

    setGameSecret: function (gameSecret) {
        if (!this.arenaXApi) {
            ARK_game_arena_connector.setGameSecret(gameSecret);
        }
    },

    getArenaName: function () {
        if (this.arenaXApi) {
            return window["arenaName"] || "unknown";
        }
        else {
            return ARK_game_arena_connector.getParam("arena_name") || "unknown";
        }
    },

    getArenaDomain: function () {
        if (this._arenaXapi) {
            return window.location.hostname;
        }

        return null;
    },

    destroy: function () {
        if (this.arenaXApi) {
            this.arenaXApi.removeAction("GAME_PAUSE");
            this.arenaXApi.removeAction("GAME_RESUME");
            this.arenaXApi.removeAction("TEST_ACTION");
        }
    }
};
